import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loadingStats: false,
  stats: {
    totalBdmUser: 0,
    avgCustomerPerBdm: 0,
    totalRevenue: 0,
    totalUnAssignBdm: 0,
  },
});

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    LOAD_AFFILIATES(state, isLoading) {
      state.loadingAffiliates = isLoading;
    },
    SET_PAGINATION(state, pagination) {
      state.pagination = pagination;
    },
    LOAD_STATS(state, isLoading) {
      state.loadingStats = isLoading;
    },
    SET_STATS(state, stats) {
      state.stats = stats;
    },
  },

  actions: {
    async getAffiliates({ commit }, params) {
      try {
        const res = await this.$api.get("/v1/portal/affiliates", {
          params,
        });
        const { data, pagination } = res.data;
        return { data, pagination };
      } catch (e) {
        errorHandler(e);
      }
    },
    async getAffiliateStatistics({ commit }) {
      try {
        commit("LOAD_STATS", true);
        const { data: res } = await this.$api.get(
          "/v1/portal/affiliates/dashboard/stats",
        );
        commit("SET_STATS", res.data);
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_STATS", false);
      }
    },
  },
};
